import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';
import SowModal from './SowModal';
import MarkSowModal from './MarkSowModal';
import MarkFertilizerModal from './MarkFertilizerModal';
import MarkPesticideModal from './MarkPesticideModal';
import MarkTillageModal from './MarkTillageModal';
import MarkHarvestModal from './MarkHarvestModal';
import FertilizeModal from './FertilizeModal';
import PlotModificationModal from './PlotTillageModal';
import HarvestModal from './HarvestModal';
import PlantProtectionModal from './PlantProtectionModal';
import { checkSowButtonState, checkPlotsHaveNoPlant, checkSelectedPlants, groupFertilizers, groupPesticides, groupTillings } from '../../commonFunctions';
import { getSelectedLang } from '../../common';
import Spinner from 'react-bootstrap/Spinner';
import '../../css/general.css'
import '../../css/plotOperation.css'
import { postContentWithAction } from '../../apiConnect';
import AppContext from '../../AppContext';
import AccordionContext from 'react-bootstrap/AccordionContext'
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ActionSelectionModal = (props) => {
    const { t } = useTranslation();
    const { auth } = useContext(AppContext);

    const [sowModalDisabled, setSowButtonDisabled] = useState(true);
    const [harvestModalDisabled, setHarvestModalDisabled] = useState(true);
    const [fertilizerModalDisabled, setFertilizerButtonDisabled] = useState(true);
    const [pesticideModalDisabled, setPesticideButtonDisabled] = useState(true);
    const [tillageDisabled, setTillageDisabled] = useState(true);
    const [harvestsDisabled, setHarvestsDisabled] = useState(true);

    const [selectedPlots, setSelectedPlots] = useState([]);
    const [selectedPlotsCount, setSelectedPlotsCountText] = useState('');
    const [sowModalShow, setSowModalShow] = useState(false);

    const [markSowModalShow, setMarkSowModalShow] = useState(false);
    const [markFertilizerModalShow, setMarkFertilizerModalShow] = useState(false);
    const [markPesticideModalShow, setMarkPesticideModalShow] = useState(false);
    const [markTillageModalShow, setMarkTillageModalShow] = useState(false);
    const [markHarvestModalShow, setMarkHarvestModalShow] = useState(false);

    const [fertilizeModalShow, setFertilizeModalShow] = useState(false);
    const [plotModificationModalShow, setPlotModificationModalShow] = useState(false);
    const [harvestModalShow, setharvestModalShow] = useState(false);
    const [plantProtectionModalShow, setPlantProtectionModalShow] = useState(false);
    const [fertAfterSow, setFertAfterSow] = useState(false);

    const [selectMultiPlotEvent, setSelectMultiPlotEvent] = useState({ time: null, selectedElement: null });
    const [addMode, setAddMode] = useState(true);

    const [sowsLoading, setSowsLoading] = useState(false);
    const [fertsLoading, setFertsLoading] = useState(false);
    const [pestsLoading, setPestsLoading] = useState(false);
    const [tillagesLoading, setTillagesLoading] = useState(false);
    const [harvestsLoading, setHarvestsLoading] = useState(false);

    const [availableSows, setAvailableSows] = useState([]);
    const [availableFertilizings, setAvailableFertilizings] = useState([]);
    const [availablePlantProtections, setAvailablePlantProtections] = useState([]);
    const [availableTillings, setAvailableTillings] = useState([]);
    const [availableHarvests, setAvailableHarvests] = useState([]);

    const buttonStyle = {
        margin: '10px'
    }

    useEffect(() => {
        setAddMode(props.addMode);
    }, [props.addMode]);

    useEffect(() => {
        setSelectedPlots(props.selectedplots);
        if (props.selectedplots) {
            let ha = Math.round((props.selectedplots.reduce((total, a) => total + a.area, 0) * 100)) / 100;
            setSelectedPlotsCountText(`${props.selectedplots.length + t('Units')} / ${ha}ha`);
        }

        setHarvestModalDisabled(checkPlotsHaveNoPlant(props.selectedplots));

        if (props.show) {
            checkSows();
            checkFerts();
            checkPests();
            checkTillages();
            checkHarvests();
        }
    }, [props.selectedplots]);

    let checkSows = () => {
        setSowButtonDisabled(true);
        setSowsLoading(true);
        setAvailableSows([]);

        // Function for API call to get sowings for the selected plots
        const getSows = (callback) => {
            // Prepare plotIds for the API call
            var plotIds = [];
            props.selectedplots.forEach(p => {
                plotIds.push({ plotId: p.apNumber });
            });
            postContentWithAction(auth.getAccessToken(), 'sow', 'sowsForPlots', { models: plotIds, lang: getSelectedLang() }, callback);
        };

        /* ADDING */
        if (props.addMode) {
            setSowButtonDisabled(checkSowButtonState(props.selectedplots));
        }
        /* ASSINGMENTS */
        else if (props.assignmentMode) {
            var assignments = props.assignments;
            getSows((data) => {
                data = data.filter((sow) => assignments.find(a => a.operNo === sow.number) && !sow.sowingDate);
                setSowsLoading(false);

                if (data.length > 0) {
                    setSowButtonDisabled(false);
                    data.map((sow) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === sow.plotId);
                        sow.plotName = plotData.name + " - " + plotData.apChar;
                        sow.plotArea = plotData.area;
                        return sow;
                    })
                    setAvailableSows(data);
                }
                else {
                    setSowButtonDisabled(true);
                }
            });
        }
        /* MARK AS DONE */
        else {
            let multiPlant = checkSowButtonState(props.selectedplots);

            // only one plant
            if (!multiPlant && props.selectedplots && props.selectedplots.length) {
                getSows((data) => {
                    data = data.filter((sow) => sow.sowingDate || sow.actionDate);
                    setSowsLoading(false);

                    if (data.length > 0) {
                        setSowButtonDisabled(false);
                        data.map((sow) => {
                            var plotData = props.selectedplots.find(p => p.apNumber === sow.plotId);
                            sow.plotName = plotData.name + " - " + plotData.apChar;
                            sow.plotArea = plotData.area;
                            return sow;
                        })
                        setAvailableSows(data);
                    }
                    else {
                        setSowButtonDisabled(true);
                    }
                });
            }
            else {
                setSowButtonDisabled(true);
                setSowsLoading(false);
            }
        }
    };

    let checkPests = () => {
        if (!props.selectedplots) {
            setPesticideButtonDisabled(true);
            setPestsLoading(false);
            setAvailablePlantProtections([]);
            return;
        }
        setPesticideButtonDisabled(true);
        setPestsLoading(true);
        setAvailablePlantProtections([]);

        const getPests = (callback) => {
            var plotIds = [];
            props.selectedplots.forEach(p => {
                plotIds.push({ plotId: p.apNumber });
            });

            postContentWithAction(auth.getAccessToken(), 'plotOperation', 'getPlantProtectionOperations', { models: plotIds, lang: getSelectedLang() }, callback);
        }

        if (props.addMode) {
            setPesticideButtonDisabled(false);
            
        }
        else if (props.assignmentMode) {
            var assignments = props.assignments;
            getPests((data) => {
                data = data.filter((pest) => assignments.find(a => a.operNo === pest.growthInformation.pesticideId) && !pest.growthInformation.date);
                setPestsLoading(false);

                if (data.length > 0) {
                    setPesticideButtonDisabled(false);
                    data.map((pest) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === pest.growthInformation.plotId);
                        pest.plotName = plotData.name + " - " + plotData.apChar;
                        pest.plotArea = plotData.area;
                        return pest;
                    })
                    setAvailablePlantProtections(data);
                }
                else {
                    setPesticideButtonDisabled(true);
                }
            });
        }
        else {
            getPests((protections) => {
                setPestsLoading(false);

                // Group by fertilizer and planned date:
                let grouped = groupPesticides(protections);

                if (grouped.length > 0) {
                    setPesticideButtonDisabled(false);
                    protections.map((pest) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === pest.growthInformation.plotId);
                        if (plotData) {
                            pest.plotName = plotData.name + " - " + plotData.apChar;
                            pest.plotArea = plotData.area;
                        }
                        return pest;
                    })
                    setAvailablePlantProtections(protections);
                }
                else {
                    setPesticideButtonDisabled(true);
                }
            });
        }
    };

    let checkFerts = () => {
        if (!props.selectedplots) {
            setFertilizerButtonDisabled(true);
            setFertsLoading(false);
            setAvailableFertilizings([]);
            return;
        }

        setFertilizerButtonDisabled(true);
        setFertsLoading(true);
        setAvailableFertilizings([]);

        const getFertilizers = (callback) => {
            var plotIds = [];
            props.selectedplots.forEach(p => {
                plotIds.push({ plotId: p.apNumber });
            });

            postContentWithAction(auth.getAccessToken(), 'fertilize', 'getFertilizingsForPlots', { models: plotIds, lang: getSelectedLang() }, callback);
        }

        if (props.addMode)
            setFertilizerButtonDisabled(false);
        else if (props.assignmentMode) {
            var assignments = props.assignments;
            getFertilizers((data) => {
                data = data.filter((fert) => assignments.find(a => a.operNo === fert.fertilizingId) && !fert.date);
                setFertsLoading(false);

                if (data.length > 0) {
                    setFertilizerButtonDisabled(false);
                    data.map((fert) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === fert.plotId);
                        fert.plotName = plotData.name + " - " + plotData.apChar;
                        fert.plotArea = plotData.area;
                        return fert;
                    })
                    setAvailableFertilizings(data);
                }
                else {
                    setFertilizerButtonDisabled(true);
                }
            });
        }
        else {
            getFertilizers((ferts) => {
                ferts = ferts.filter((f) => f.date || f.plannedDate);
                setFertsLoading(false);

                // Group by fertilizer and planned date:
                let grouped = groupFertilizers(ferts);

                if (grouped.length > 0) {
                    setFertilizerButtonDisabled(false);
                    ferts.map((fert) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === fert.plotId);
                        if (plotData) {
                            fert.plotName = plotData.name + " - " + plotData.apChar;
                            fert.plotArea = plotData.area;
                        }
                        return fert;
                    })
                    setAvailableFertilizings(ferts);
                }
                else {
                    setFertilizerButtonDisabled(true);
                }
            });
        }
    };

    let checkTillages = () => {
        if (!props.selectedplots) {
            setTillageDisabled(true);
            setTillagesLoading(false);
            setAvailableTillings([]);
            return;
        }

        setTillageDisabled(true);
        setTillagesLoading(true);
        setAvailableTillings([]);

        const getTillings = (callback) => {
            var plotIds = [];
            props.selectedplots.forEach(p => {
                plotIds.push({ plotId: p.apNumber });
            });

            postContentWithAction(auth.getAccessToken(), 'plotModification', 'plotModificationsForPlots', { models: plotIds, lang: getSelectedLang() }, callback);
        }

        if (props.addMode)
            setTillageDisabled(false);
        else if (props.assignmentMode) {
            var assignments = props.assignments;
            getTillings((data) => {
                data = data.filter((mod) => assignments.find(a => a.operNo === mod.number) && !mod.actionDate);
                setTillagesLoading(false);

                if (data.length > 0) {
                    setTillageDisabled(false);
                    data.map((mod) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === mod.plotId);
                        mod.plotName = plotData.name + " - " + plotData.apChar;
                        mod.plotArea = plotData.area;
                        return mod;
                    })
                    setAvailableTillings(data);
                }
                else {
                    setTillageDisabled(true);
                }
            });
        }
        else {
            getTillings((data) => {
                data = data.filter((f) => f.actionDate || f.plannedDate);
                setTillagesLoading(false);

                // Group by fertilizer and planned date:
                let grouped = groupTillings(data);

                if (grouped.length > 0) {
                    setTillageDisabled(false);
                    data.map((mod) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === mod.plotId);
                        if (plotData) {
                            mod.plotName = plotData.name + " - " + plotData.apChar;
                            mod.plotArea = plotData.area;
                        }
                        return mod;
                    })
                    setAvailableTillings(data);
                }
                else {
                    setTillageDisabled(true);
                }
            });
        }
    }

    let checkHarvests = () => {
        if (!props.selectedplots) {
            setHarvestsDisabled(true);
            setHarvestsLoading(false);
            setAvailableHarvests([]);
            return;
        }

        setHarvestsDisabled(true);
        setHarvestsLoading(true);
        setAvailableHarvests([]);

        const getHarvests = (callback) => {
            var plotIds = [];
            props.selectedplots.forEach(p => {
                plotIds.push({ plotId: p.apNumber });
            });

            postContentWithAction(auth.getAccessToken(), 'harvest', 'harvestsForPlots', { models: plotIds, lang: getSelectedLang() }, callback);
        }

        if (props.addMode)
            setHarvestsDisabled(false);
        else if (props.assignmentMode) {
            var assignments = props.assignments;
            getHarvests((data) => {
                data = data.filter((harv) => assignments.find(a => a.operNo === harv.harvestId));
                setHarvestsLoading(false);

                if (data.length > 0) {
                    setHarvestsDisabled(false);
                    data.map((harv) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === harv.plotId);
                        harv.plotName = plotData.name + " - " + plotData.apChar;
                        harv.plotArea = plotData.area;
                        return harv;
                    })
                    setAvailableHarvests(data);
                }
                else {
                    setHarvestsDisabled(true);
                }
            });
        }
        else {
            getHarvests((data) => {
                data = data.filter((f) => f.beginDate || f.plannedDate);
                setHarvestsLoading(false);

                // Group by fertilizer and planned date:
                let grouped = groupTillings(data);

                if (grouped.length > 0) {
                    setHarvestsDisabled(false);
                    data.map((harv) => {
                        var plotData = props.selectedplots.find(p => p.apNumber === harv.plotId);
                        if (plotData) {
                            harv.plotName = plotData.name + " - " + plotData.apChar;
                            harv.plotArea = plotData.area;
                        }
                        return harv;
                    })
                    setAvailableHarvests(data);
                }
                else {
                    setHarvestsDisabled(true);
                }
            });
        }
    }

    function PesticideInfo({ protection }) {
        return (
            <>
                {protection.pesticides ? protection.pesticides.map((pest, i) =>
                    <div key={i}>
                        {pest.productName}, {pest.amount} {pest.unitText}/ha
                    </div>
                ) : ''}
                {protection.fertilizings ? protection.fertilizings.map((f, i) => 
                    <div key={i}>
                        {f.productName}, {f.amount} {f.unitText}/ha
                    </div>
                ) : ''}
            </>
        );
    }

    function TillageInfo({ tillage }) {
        return (
            <>
                {tillage.description}, {tillage.count ? t('Count') + ': ' + tillage.count : ''} {tillage.depth ? ', ' + tillage.depth : ''} {tillage.unitText ? tillage.unitText : ''}
            </>
        );
    }

    function HarvestInfo({ harvest }) {
        return (
            <>
                {harvest.productName} { harvest.amount  + ' ' + harvest.unitText}
            </>
        );
    }

    function AccordionToggle({ children, eventKey, callback }) {
        const currentEventKey = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(eventKey, () => {
            callback && callback(eventKey);
        });

        return (
            <div
                onClick={decoratedOnClick}
                className={currentEventKey.activeEventKey === eventKey ? "active-panel section-button custom-accordion-select active-accordion" : "inactive-panel section-button custom-accordion-select"}
            >
                {children}
            </div>
        );
    }

    return (
        <>
            {sowModalShow === true ?
                <SowModal
                    show={sowModalShow}
                    setRefresh={() => { props.onHide(); }}
                    onHide={() => setSowModalShow(false)}
                    //onClick={() => setRefreshSows(Date.now())}
                    selectEvent={selectMultiPlotEvent}
                />
                : ''}
            {fertilizeModalShow === true ?
                <FertilizeModal
                    show={fertilizeModalShow}
                    setRefresh={() => { props.onHide(); }}
                    onHide={() => setFertilizeModalShow(false)}
                    selectEvent={selectMultiPlotEvent}
                />
                : ''}
            {plotModificationModalShow === true ?
                <PlotModificationModal
                    show={plotModificationModalShow}
                    setRefresh={() => { props.onHide(); }}
                    onHide={() => setPlotModificationModalShow(false)}
                    selectEvent={selectMultiPlotEvent}
                />
                : ''}
            {harvestModalShow === true ?
                <HarvestModal
                    show={harvestModalShow}
                    setRefresh={() => { props.onHide(); }}
                    onHide={() => setharvestModalShow(false)}
                    selectEvent={selectMultiPlotEvent}
                />
                : ''}
            {plantProtectionModalShow === true ?
                <PlantProtectionModal
                    show={plantProtectionModalShow}
                    setRefresh={() => { props.onHide(); }}
                    onHide={() => setPlantProtectionModalShow(false)}
                    selectEvent={selectMultiPlotEvent}
                />
                : ''}
            {markSowModalShow === true ?
                <MarkSowModal
                    show={markSowModalShow}
                    setRefresh={() => {
                        if (props.assignments) props.refreshAssignments();
                        else props.onHide();
                    }}
                    onHide={() => {
                        setMarkSowModalShow(false);
                        checkSows();
                    }}
                    onClick={() => { }}
                    selectEvent={selectMultiPlotEvent}
                    showFertilizingModal={() => {
                        setFertAfterSow(true);
                        setMarkFertilizerModalShow(true);
                    }}
                    fertilizingModalDisabled={fertilizerModalDisabled}
                    assignments={props.assignments ? props.assignments : null}
                    refreshAssignments={() => { if (props.assignments) props.refreshAssignments(); }}
                />
                : ''}
            {markFertilizerModalShow === true ?
                <MarkFertilizerModal
                    show={markFertilizerModalShow}
                    afterSow={fertAfterSow}
                    setRefresh={() => {
                        if (props.assignments) props.refreshAssignments();
                        else props.onHide();
                    }}
                    onHide={() => {
                        setFertAfterSow(false);
                        setMarkFertilizerModalShow(false);
                        checkFerts();
                    }}
                    onClick={() => { }}
                    selectEvent={selectMultiPlotEvent}
                    assignments={props.assignments ? props.assignments : null}
                />
                : ''}
            {markPesticideModalShow === true ?
                <MarkPesticideModal
                    show={markPesticideModalShow}
                    setRefresh={() => {
                        if (props.assignments) props.refreshAssignments();
                        else props.onHide();
                    }}
                    onHide={() => {
                        setMarkPesticideModalShow(false);
                        checkPests();
                        checkFerts();
                    }}
                    onClick={() => { }}
                    selectEvent={selectMultiPlotEvent}
                    assignments={props.assignments ? props.assignments : null}
                />
                : ''}
            {markTillageModalShow === true ?
                <MarkTillageModal
                    show={markTillageModalShow}
                    setRefresh={() => {
                        if (props.assignments) props.refreshAssignments();
                        else props.onHide();
                    }}
                    onHide={() => {
                        setMarkTillageModalShow(false);
                        checkTillages();
                    }}
                    onClick={() => { }}
                    selectEvent={selectMultiPlotEvent}
                    assignments={props.assignments ? props.assignments : null}
                />
                : ''}
            {markHarvestModalShow === true ?
                <MarkHarvestModal
                    show={markHarvestModalShow}
                    setRefresh={() => { props.onHide(); }}
                    onHide={() => {
                        setMarkHarvestModalShow(false);
                        checkHarvests();
                    }}
                    onClick={() => { }}
                    selectEvent={selectMultiPlotEvent}
                    assignments={props.assignments ? props.assignments : null}
                />
                : ''}

            <Modal show={props.show} onHide={props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">{t('SelectAction')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                    {addMode === true ?
                        // Adding operations for multiple plots
                            <div className="action-modal-max-width">
                                <div>
                                <Button style={buttonStyle} variant="success" className="btn-show-more"
                                    disabled={sowModalDisabled ? true : false}
                                    onClick={() => {
                                        setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                        setSowModalShow(true);

                                        }}>{t('Sowings')}</Button>
                                    {sowModalDisabled ?
                                        <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={
                                            <Tooltip id="overlay" className="mark-action-tooltip">
                                                <br />
                                                <p>{t('MarkSowTooltip')}</p>
                                            </Tooltip>
                                        }>
                                            <Button variant="outline-success" onClick={(e) => { }}>
                                                <b>?</b>
                                            </Button>
                                        </OverlayTrigger> : ''}
                                </div>
                            <Button style={buttonStyle} variant="success" className="btn-show-more"
                                onClick={() => {
                                setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                setFertilizeModalShow(true);
                            }}>{t('Fertilizinglist')}</Button>
                            <Button style={buttonStyle} variant="success" className="btn-show-more"
                                onClick={() => {
                                setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                setPlotModificationModalShow(true);
                            }}>{t('Tilling_Cultivation')}</Button>
                                <Button style={buttonStyle} variant="success" className="btn-show-more"
                                disabled={pesticideModalDisabled ? true : false}
                                onClick={() => {
                                setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                setPlantProtectionModalShow(true);
                            }}>{t('Observations_PlantProtection')}</Button>
                            <Button style={buttonStyle} variant="success" className="btn-show-more"
                                disabled={harvestModalDisabled ? true : false}
                                onClick={() => {
                                setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                setharvestModalShow(true);
                            }}>{t('Yield')}</Button>
                        </div>

                        // Marking as done
                            : <div className="action-modal-max-width">
                                <Accordion defaultActiveKey="1" className="action-select-accordion">
                                    {/* SOWS */}
                                    <Card>
                                        <Card.Header className="p-0">
                                            <AccordionToggle eventKey="1">
                                                <div className="action-sel-accordion-header">{t('Sowings')} ({availableSows.length})
                                                    {sowModalDisabled ?
                                                        <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={
                                                            <Tooltip id="overlay" className="mark-action-tooltip">
                                                                <br />
                                                                <p>{t('MarkSowTooltip')}</p>
                                                            </Tooltip>
                                                        }>
                                                            <Button variant="outline-success" className="mark-action-tooltip-btn" onClick={(e) => { e.stopPropagation(); } }>
                                                                <b>?</b>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        : ''}
                                                </div>
                                                <Button style={buttonStyle} variant="primary" className="accordion-header-button action-modal-accordion"
                                                    disabled={sowModalDisabled ? true : false}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                                        setMarkSowModalShow(true);
                                                    }}>
                                                    {sowsLoading ?
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                        />
                                                        : ''}
                                                    {t('MarkDoneShort')}
                                                </Button>
                                            </AccordionToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="1" className="action-sel-accordion-body">
                                            <Container>
                                                {availableSows.map((sow, i) =>
                                                    <Row key={i} className="action-sel-row">
                                                        <Col xs={7}><b>{sow.plotName}</b> ({sow.plotArea} ha): </Col><Col>{sow.description}, {(sow.amount).toFixed(0)} {sow.unitText}/ha</Col>
                                                    </Row>
                                                )}
                                                </Container>
                                        </Accordion.Collapse>
                                    </Card>

                                    {/* FERTILIZINGS */}
                                    <Card>
                                        <Card.Header className="p-0">
                                            <AccordionToggle eventKey="2">
                                                <div className="action-sel-accordion-header">{t('Fertilizinglist')} ({availableFertilizings.length})</div>
                                                <Button style={buttonStyle} variant="primary" className="accordion-header-button"
                                                    disabled={fertilizerModalDisabled ? true : false}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                                        setMarkFertilizerModalShow(true);
                                                    }}>
                                                    {fertsLoading ?
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                        />
                                                        : ''}
                                                    {t('MarkDoneShort')}
                                                </Button>
                                            </AccordionToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="2">
                                            <Container>
                                                {availableFertilizings.map((fert, i) =>
                                                    <Row key={i} className="action-sel-row">
                                                        <Col xs={7}><b>{fert.plotName}</b> ({fert.plotArea} ha): </Col><Col>{fert.productName??fert.description}, {(fert.amount).toFixed(0)} {fert.unitText}/ha</Col>
                                                    </Row>
                                                )}
                                            </Container>
                                        </Accordion.Collapse>
                                    </Card>

                                    {/* PESTICIDE OPERATIONS */}
                                    <Card>
                                        <Card.Header className="p-0">
                                            <AccordionToggle eventKey="3">
                                                <div className="action-sel-accordion-header">{t('PlantProtection')} ({availablePlantProtections.length})</div>
                                                <Button style={buttonStyle} variant="primary" className="accordion-header-button"
                                                    disabled={pesticideModalDisabled ? true : false}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                                        setMarkPesticideModalShow(true);
                                                    }}>{pestsLoading ?
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                        />
                                                        : ''}
                                                    {t('MarkDoneShort')}
                                                </Button>
                                            </AccordionToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="3">
                                            <Container>
                                                {availablePlantProtections.map((protection, i) =>
                                                    <Row key={i} className="action-sel-row">
                                                        <Col xs={7}><b>{protection.plotName}</b> ({protection.plotArea} ha): </Col>
                                                        <Col>
                                                            <PesticideInfo protection={protection} />
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Container>
                                        </Accordion.Collapse>
                                    </Card>

                                    {/* TILLAGES */}
                                    <Card>
                                        <Card.Header className="p-0">
                                            <AccordionToggle eventKey="4">
                                                <div className="action-sel-accordion-header">{t('Tilling_Cultivation')} ({availableTillings.length})</div>
                                                <Button style={buttonStyle} variant="primary" className="accordion-header-button"
                                                    disabled={tillageDisabled ? true : false}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                                        setMarkTillageModalShow(true);
                                                    }}>{tillagesLoading ?
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                        />
                                                        : ''}
                                                    {t('MarkDoneShort')}
                                                </Button>
                                            </AccordionToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="4">
                                            <Container>
                                                {availableTillings.map((t, i) =>
                                                    <Row key={i} className="action-sel-row">
                                                        <Col xs={7}><b>{t.plotName}</b> ({t.plotArea} ha): </Col>
                                                        <Col>
                                                            <TillageInfo tillage={t} />
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Container>
                                        </Accordion.Collapse>
                                    </Card>

                                    {/* HARVESTS */}
                                    <Card>
                                        <Card.Header className="p-0">
                                            <AccordionToggle eventKey="5">
                                                <div className="action-sel-accordion-header">{t('Yield')} ({availableHarvests.length})</div>
                                                <Button style={buttonStyle} variant="primary" className="accordion-header-button"
                                                    disabled={harvestsDisabled ? true : false}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectMultiPlotEvent({ time: Date.now(), selectedElement: null, selectedPlots: selectedPlots });
                                                        setMarkHarvestModalShow(true);
                                                    }}>{harvestsLoading ?
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                        />
                                                        : ''}
                                                    {t('MarkDoneShort')}
                                                </Button>
                                            </AccordionToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="5">
                                            <Container>
                                                {availableHarvests.map((h, i) =>
                                                    <Row key={i} className="action-sel-row">
                                                        <Col xs={7}><b>{h.plotName}</b> ({h.plotArea} ha): </Col>
                                                        <Col>
                                                            <HarvestInfo harvest={h} />
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Container>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>
                          </div>
                    }
                    </Form>
                </Modal.Body>   
                <Modal.Footer className="modal-footer-right-align">
                    <Button variant="outline-secondary" onClick={props.onHide}>{t('Close')}</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ActionSelectionModal;